import {
  Avatar,
  Box,
  Center,
  Text,
  HStack,
  VStack,
  Flex,
} from "@chakra-ui/react";
import { FaLinkedin, FaSpotify } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";

import AnimeAvatar from "../../assets/altAvatar.webp";
import { FC } from "react";
import { Link } from "react-router-dom";

// 🌟 RETRO 90s PROFILE COMPONENT 🌟

export const Profile: FC = () => {
  return (
    <Center py={4}>
      <Box
        maxW={"280px"}
        w={"full"}
        bg="linear-gradient(180deg, #C0C0C0, #A0A0A0)"
        border="3px outset #FFFFFF"
        boxShadow="4px 4px 0px #404040"
        p={0}
        textAlign={"center"}
      >
        {/* Window Title Bar */}
        <Flex
          bg="linear-gradient(90deg, #800080, #FF00FF)"
          color="white"
          px={2}
          py={1}
          justify="space-between"
          align="center"
          borderBottom="2px solid #808080"
        >
          <Text fontFamily="'Comic Sans MS', cursive" fontWeight="bold" fontSize="xs">
            👤 Profile.exe
          </Text>
          <Flex gap={1}>
            <Box w="12px" h="12px" bg="#C0C0C0" border="1px outset white" textAlign="center" lineHeight="10px" fontSize="8px">_</Box>
            <Box w="12px" h="12px" bg="#C0C0C0" border="1px outset white" textAlign="center" lineHeight="10px" fontSize="8px">□</Box>
            <Box w="12px" h="12px" bg="#C0C0C0" border="1px outset white" textAlign="center" lineHeight="10px" fontSize="8px">✕</Box>
          </Flex>
        </Flex>

        <Box p={4}>
          {/* Avatar with glow effect */}
          <Box
            display="inline-block"
            border="3px ridge #FF00FF"
            borderRadius="50%"
            p={1}
            mb={3}
            sx={{
              animation: "avatar-glow 2s infinite",
              "@keyframes avatar-glow": {
                "0%, 100%": { boxShadow: "0 0 5px #FF00FF" },
                "50%": { boxShadow: "0 0 20px #FF00FF, 0 0 30px #00FFFF" },
              },
            }}
          >
            <Avatar 
              size={"lg"} 
              src={AnimeAvatar}
              border="2px solid #000000"
            />
          </Box>

          {/* Social Links */}
          <VStack spacing={2} mb={3}>
            <Link target="_blank" to="https://www.linkedin.com/in/yosri-bedoui">
              <HStack
                bg="#0000FF"
                color="white"
                px={3}
                py={1}
                border="2px outset #4444FF"
                fontFamily="'Comic Sans MS', cursive"
                fontSize="sm"
                fontWeight="bold"
                _hover={{ 
                  bg: "#0000AA",
                  border: "2px inset #0000FF",
                }}
              >
                <FaLinkedin />
                <Text>LinkedIn</Text>
              </HStack>
            </Link>

            <Link target="_blank" to="https://www.github.com/yosriBed">
              <HStack
                bg="#333333"
                color="#00FF00"
                px={3}
                py={1}
                border="2px outset #666666"
                fontFamily="'Comic Sans MS', cursive"
                fontSize="sm"
                fontWeight="bold"
                textShadow="0 0 5px #00FF00"
                _hover={{ 
                  bg: "#222222",
                  border: "2px inset #333333",
                  boxShadow: "0 0 10px #00FF00",
                }}
              >
                <FaGithub />
                <Text>Github</Text>
              </HStack>
            </Link>

            <Link
              target="_blank"
              to="https://open.spotify.com/user/19nsh91gyvywvsi8ueve3sw7y?si=c9b2d726a700492f"
            >
              <HStack
                bg="#1DB954"
                color="white"
                px={3}
                py={1}
                border="2px outset #1ED760"
                fontFamily="'Comic Sans MS', cursive"
                fontSize="sm"
                fontWeight="bold"
                _hover={{ 
                  bg: "#1AA34A",
                  border: "2px inset #1DB954",
                }}
              >
                <FaSpotify />
                <Text>Spotify</Text>
              </HStack>
            </Link>
          </VStack>

          {/* Bio Text */}
          <Box
            bg="#FFFFCC"
            border="2px inset #808080"
            p={2}
            fontFamily="'Comic Sans MS', cursive"
            fontSize="xs"
            color="black"
            textAlign="left"
          >
            <Text fontWeight="bold" color="#FF0000">
              📝 About Me:
            </Text>
            <Text>
              Software Engineer 💻
              <br />
              FullStack Developer 🌐
              <br />
              Tech Consultant 🔧
            </Text>
          </Box>
        </Box>
      </Box>
    </Center>
  );
};
